import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;
const axios = createClient({ baseUrl, isAdminSite: true });

//meet banner
export const getMeetBannerData = () => axios.post(`/meetingbannerdata`);
export const updateBannerData = (data) =>
  axios.post(`/add_edit_meetingbanner`, data);

// Consolidated meetings actions (replacing previous & upcoming)
export const getMeetingsData = (data) =>
  axios.get(`/meetings`, data ? { params: data } : {});
export const getMeeting = (id) => axios.get(`/meetings/${id}`);
export const addOrUpdateMeeting = (data) => axios.post(`/meetings`, data);
export const deleteMeeting = (id) => axios.delete(`/meetings/${id}`);
export const orderMeetingsData = (data) => axios.post(`/meetings/order`, data);

// Legacy endpoints - to be deprecated after migration
export const getUpcomingMeetData = (data) =>
  axios.post(`/upcomingmeetdata`, data);
export const addEditUpcomingMeetData = (data) =>
  axios.post(`/add_edit_upcomingmeet`, data);
export const getPreviewMeetData = (data) =>
  axios.post(`/previewmeetdata`, data);
export const addEditPreviewMeetData = (data) =>
  axios.post(`/add_edit_previewmeet`, data);
export const orderPreviewMeetData = (data) =>
  axios.post(`/previewmeetdata_order`, data);
export const deletePreviewMeetData = (data) =>
  axios.post(`/delete_previewmeet`, data);

//registered meetings
export const getRegisteredMeetings = (data) =>
  axios.get(`/registered-meetings`, data ? { params: data } : {});
